import { useSnackbar } from 'notistack'
import React, { FC, useState } from 'react'
import { CostumerPropsType } from '../../../api/appAPI'
import { EnqueueSnackbarType, showMessage } from '../../../components/common/Helpers'
import CostumerUIBox from './CostumerUIBox'

interface IProps {
    statusList: string[]
    onDialogClose(): void
    addCostumer(costumerProps: CostumerPropsType, enqueueSnackbar: EnqueueSnackbarType): void
}

const DefineCostumer: FC<IProps> = (props) => {
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [status, setStatus] = useState('')
    const [phone, setPhone] = useState('')
    const [zip, setZip] = useState('')
    const [address1, setAddress1] = useState('')
    const [address2, setAddress2] = useState('')
    const [city, setCity] = useState('')
    const [province, setProvince] = useState('')
    const [country, setCountry] = useState('United Stated')
    const [note, setNote] = useState('')

    const { enqueueSnackbar } = useSnackbar()

    const handleFirstNameChange = (event: React.ChangeEvent<{ value: string }>) => {
        setFirstName(event.target.value.replace(/['"]/, ''))
    }
    const handleLastNameChange = (event: React.ChangeEvent<{ value: string }>) => {
        setLastName(event.target.value.replace(/['"]/, ''))
    }
    const handleEmailChange = (event: React.ChangeEvent<{ value: string }>) => {
        setEmail(event.target.value.replace(/['"]/, ''))
    }
    const handlePhoneChange = (value: string) => {
        setPhone(value.replace(/['"]/, ''))
    }
    const handleZipChange = (event: React.ChangeEvent<{ value: string }>) => {
        setZip(event.target.value.replace(/['"]/, ''))
    }
    const handleAddress1Change = (event: React.ChangeEvent<{ value: string }>) => {
        setAddress1(event.target.value.replace(/['"]/, ''))
    }
    const handleAddress2Change = (event: React.ChangeEvent<{ value: string }>) => {
        setAddress2(event.target.value.replace(/['"]/, ''))
    }
    const handleCityChange = (event: React.ChangeEvent<{ value: string }>) => {
        setCity(event.target.value.replace(/['"]/, ''))
    }
    const handleProvinceChange = (value: string) => {
        setProvince(value.replace(/['"]/, ''))
    }
    const handleCountryChange = (event: React.ChangeEvent<{ value: string }>) => {
        setCountry(event.target.value.replace(/['"]/, ''))
    }
    const handleNoteChange = (event: React.ChangeEvent<{ value: string }>) => {
        setNote(event.target.value.replace(/['"]/, ''))
    }

    const handleStatusChange = (value: string) => {
        setStatus(value)
    }

    const handleCreateClick = () => {
        if (firstName === '') {
            showMessage(enqueueSnackbar, "Enter first name")
            return
        }

        if (lastName === '') {
            showMessage(enqueueSnackbar, "Enter last name")
            return
        }

        if (email === '') {
            showMessage(enqueueSnackbar, "Enter email")
            return
        }

        // if (props.statusList.length > 0) {
        //     if (status === '') {
        //         showMessage(enqueueSnackbar, "Choose status")
        //         return
        //     }
        // }

        const costumerProps = {
            firstName, lastName,
            email, status, phone, zip, address1, address2,
            city, province, country, companyEmail: '', note
        } as CostumerPropsType

        props.addCostumer(costumerProps, enqueueSnackbar)
        props.onDialogClose()

        // setFirstName('')
        // setLastName('')
        // setEmail('')
        // setPhone('')
        // setZip('')
        // setAddress1('')
        // setAddress2('')
        // setCity('')
        // setProvince('')
    }

    return (
        <CostumerUIBox
            title='New Customer'
            statusList={props.statusList}
            firstName={{
                value: firstName,
                onChange: handleFirstNameChange
            }}
            lastName={{
                value: lastName,
                onChange: handleLastNameChange
            }}
            email={{
                value: email,
                onChange: handleEmailChange
            }}
            status={{
                value: status,
                onChange: handleStatusChange
            }}
            phone={{
                value: phone,
                onChange: handlePhoneChange
            }}
            zip={{
                value: zip,
                onChange: handleZipChange
            }}
            address1={{
                value: address1,
                onChange: handleAddress1Change
            }}
            address2={{
                value: address2,
                onChange: handleAddress2Change
            }}
            city={{
                value: city,
                onChange: handleCityChange
            }}
            province={{
                value: province,
                onChange: handleProvinceChange
            }}
            country={{
                value: country,
                onChange: handleCountryChange
            }}
            note={{
                value: note,
                onChange: handleNoteChange
            }}


            button={{
                text: 'Create',
                onClick: handleCreateClick
            }}

            onDialogClose={props.onDialogClose}

        // editable
        />
    )
}

export default DefineCostumer